import VueGtag from 'vue-gtag';

class Analytics {
  install(Vue, { router }) {
    Vue.use(
      VueGtag,
      {
        config: {
          id: process.env.VUE_APP_GA_MEASUREMENT_ID,
        },
        onReady() {
          window.gtag('config', process.env.VUE_APP_GA_MEASUREMENT_ID, {
            debug_mode: !window.location.host.startsWith('app'),
            send_page_view: false,
          });
        },
      },
      router
    );
    Vue.prototype.$analytics = this;
  }

  event(category, action, label, value, customFields) {
    // console.log('sending event', category, action, label, value, customFields);
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
      ...(customFields || {}),
    });
  }
}

export default new Analytics();
